import { Autocomplete, Box, Button, Card, Divider, FormControl, Grid, IconButton, MenuItem, Select, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Controller, set, useForm } from 'react-hook-form'
import { Helpers } from '../../../services/Helpers';
import { AddToPhotos, Visibility, ZoomIn, ZoomOut, FitScreen, Close } from '@mui/icons-material';
import { PaymentServices } from './BookingPaymentServices';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';
import Swal from 'sweetalert2';
import { BookingService } from '../../Booking/Service';
import { use } from 'react';

const AddEditPayment = (props) => {
  const {navigaetedFrom,bookingDetails,closePaymentEntryDialog,paymentRecordData,isEdit} = props;
  const initialState = {
    bookingId : '',
    bookingNumber:'',
    bookingAmount:'',
    bookingBalanceAmount : '', // Outstanding balance at time of payment
    customerPaidAmount : '', // Amount customer actually paid
    image : '',
    paymentMethod : 'CASH', // ENUM('CASH', 'UPI_QR', 'APP_RAZORPAY')
    expertPaymentStatus : 'NOT_TRANSFERRED', // ENUM( 'TRANSFERRED_FULL', 'PAID_FEES_ONLY', 'PAID_PARTIAL', 'NOT_TRANSFERRED' ),
    amountReceived : '', // Actual amount received by CuDel
    isPayoutEligible : false, // Whether expert qualifies for payout
    referenceNumber : '',
    customerFeedback : '',
    paidBalanceAmount : '', // Balance after payment (negative = adjustment, positive = tip/adjustment
    tipAdjustmentType : 'NONE', // ENUM('NONE', 'TIP', 'ADJUSTMENT')
    paymentRemarks : '',

  }
  const [bookingPaymentData, setBookingPaymentData] = useState(initialState);
  useEffect(()=>{
    if ( isEdit && paymentRecordData ) {
      reset(paymentRecordData);
      setBookingPaymentData(paymentRecordData);
      setIsBookingIdVerified(true);
    }
  },[isEdit,paymentRecordData])
  const {control,handleSubmit,watch,setValue,reset,formState: { errors ,isDirty}} = useForm({
    mode:"onChange",
    defaultValues:bookingPaymentData
  });

  const [completedBookings, setCompletedBookings] = useState([]);
  /*================== image upload realted ====================== */
  const [imageUploadResponseDetails, setImageUploadResponseDetails] = useState({});
  const [imgModalOpen, setImgModalOpen] = useState(false);

  const openImgModal = () => {
      setImgModalOpen(true);
  };

  const closeModal = () => {
      setImgModalOpen(false);
  };

  const imgData = {
      path: 'booking-payment',
      img_type: "single"
  };
  const imgUploadResponse = (data) => {
      setImageUploadResponseDetails(data);
      setValue('image', data.imageName, { shouldDirty: true, shouldValidate: true });
  }
  // Image preview state and controls
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");
  const [zoom, setZoom] = useState(1);

  const openImagePreview = (src) => {
    setPreviewSrc(src);
    setZoom(1);
    setPreviewOpen(true);
  };
  const closeImagePreview = () => setPreviewOpen(false);
  const zoomIn = () => setZoom((z) => Math.min(5, +(z + 0.25).toFixed(2)));
  const zoomOut = () => setZoom((z) => Math.max(0.25, +(z - 0.25).toFixed(2)));
  const resetZoom = () => setZoom(1);
  const bookingNumber = watch('bookingNumber');
  const paymentMethod = watch('paymentMethod');  
  const customerPaidAmount = watch('customerPaidAmount');
  const bookingBalanceAmount = watch('bookingBalanceAmount');
  const expertPaymentStatus = watch('expertPaymentStatus');
  const cudelReceivedAmount = watch('amountReceived') 
  useEffect(()=>{
    if(!isEdit){
      setIsBookingIdVerified(false);
      // setValue('bookingId','');
      setValue('bookingAmount','0');
      setValue('bookingBalanceAmount','0');
    }
  },[bookingNumber])

  useEffect(()=>{
    if(paymentMethod == 'APP_RAZORPAY'){
      setValue('expertPaymentStatus','TRANSFERRED_FULL');
      setValue('amountReceived',bookingBalanceAmount);
      setValue('isPayoutEligible',true);
      setValue('customerPaidAmount',bookingBalanceAmount);
    }
  },[paymentMethod])
  useEffect(()=>{
    if(customerPaidAmount && bookingBalanceAmount){
      setValue('paidBalanceAmount',parseFloat(cudelReceivedAmount)-parseFloat(bookingBalanceAmount));
      if(expertPaymentStatus == 'TRANSFERRED_FULL'){
        setValue('amountReceived',customerPaidAmount);
      }
    }
  },[customerPaidAmount,bookingBalanceAmount,cudelReceivedAmount]);

  const paidBalanceAmount = watch('paidBalanceAmount');
  useEffect(()=>{
    if(paidBalanceAmount<0){
      setValue('tipAdjustmentType','ADJUSTMENT');
    } else if(paidBalanceAmount == 0){
      setValue('tipAdjustmentType','NONE');
    }
  },[paidBalanceAmount]);
  useEffect(()=>{
    if(expertPaymentStatus == 'NOT_TRANSFERRED' || expertPaymentStatus == 'PAID_FEES_ONLY'){
      setValue('isPayoutEligible',false);
      // setValue('amountReceived','0');
    }else if(expertPaymentStatus == 'TRANSFERRED_FULL'){
      setValue('amountReceived',customerPaidAmount);      
      setValue('isPayoutEligible',true);
    }
    else{
      setValue('isPayoutEligible',true);
    }
  },[expertPaymentStatus]);

  const handleFormSubmission = async (data)=>{
    console.log(" submitted form data:",data);
    const {id,bookingNumber,bookingAmount,...restAll} = data;
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Save it!',
      cancelButtonText: 'No, cancel',
      allowOutsideClick: false,
    })
    if(!result.isConfirmed){
      return;
    }
    Swal.fire({
      title: 'Please Wait...',
      showConfirmButton: false, 
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading()
      },  
    })
    try {
      if(isEdit){
        console.log("edit mode:",data);
        const updateResponse = await PaymentServices.updatePaymentRecord(restAll,bookingPaymentData.id);
        console.log("updateResponse:",updateResponse);
        if(updateResponse.success=='1'){
          Swal.fire({
            title: 'Payment record updated successfully',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          const data = {
            id: updateResponse.data.id,
            bookingId : updateResponse.data.bookingId,
            bookingNumber:updateResponse.data.booking.bookingNumber,
            bookingAmount:updateResponse.data.booking.total,
            bookingBalanceAmount : updateResponse.data.bookingBalanceAmount,
            customerPaidAmount : updateResponse.data.customerPaidAmount,
            image : updateResponse.data.image,
            paymentMethod : updateResponse.data.paymentMethod,
            expertPaymentStatus : updateResponse.data.expertPaymentStatus,
            amountReceived : updateResponse.data.amountReceived,
            isPayoutEligible : updateResponse.data.isPayoutEligible,
            referenceNumber : updateResponse.data.referenceNumber,
            customerFeedback : updateResponse.data.customerFeedback,
            paidBalanceAmount : updateResponse.data.paidBalanceAmount,
            tipAdjustmentType : updateResponse.data.tipAdjustmentType,
            paymentRemarks : updateResponse.data.paymentRemarks,
          }
          setBookingPaymentData(data);
          reset(data);
          setImageUploadResponseDetails({});
        }
      } else{
        const createResponse = await PaymentServices.createPaymentRecord(restAll);
        if(createResponse.success=='1'){
          Swal.fire({
            title: 'Payment record added successfully',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          reset(initialState);
          setImageUploadResponseDetails({});
          // closePaymentEntryDialog();
        }
      }
    } catch (error) {
      Swal.fire(error.message,'','error')
    }
  }

  const [isBookingIdVerified, setIsBookingIdVerified] = useState(false);

  const fetchPendingBookingAmount=async(bookingId)=>{
    console.log("booking id:",bookingId);
    const response = await PaymentServices.fetchPendingAmount(bookingId);
    if(response.success=='1'){
      console.log("last payment record:",response.data);
      if(response.data.pendingAmount > 0){     
        setValue('bookingBalanceAmount',response.data.pendingAmount);
      }else{
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No Pending Balance Found for this Booking!',
          allowOutsideClick: false,
          // timer: 1500
        }).then((result) => {
          if (result.isConfirmed) {
            reset(initialState);
            setIsBookingIdVerified(false);
            if(isEdit){
              closePaymentEntryDialog();
            }
          }
        })
      }
    }
  }
  // useEffect(()=>{
  //   if(bookingDetails && bookingDetails.id){
  //     fetchPendingBookingAmount(bookingDetails.id);
  //   }
  // },[bookingDetails])

  const[verifyingBookingNumber,setVerifyingBookingNumber] = useState(false);
  const handleBookingNumberValidation = async ()=>{
    let bookingId = null;
      // Extract digits after "BI"
    const match = bookingNumber.match(/BI(\d+)$/);
    
    if (match) {
      bookingId = match[1]; // Gets the captured group (digits after BI)
      console.log('Booking ID:', bookingId);
    }else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Invalid Booking Number. Only digits and "BI" allowed. Format: [digits]BI[digits]',
        allowOutsideClick: false,
        // timer: 1500
      })
      return;
    }
    if(bookingId){
      setVerifyingBookingNumber(true);
      const response = await BookingService.bookingDetailById(bookingId);
      if(response.success=='1'){
        console.log("booking details:",response.data);

        setValue('bookingId',bookingId);
        // setValue('bookingNumber',bookingDetails.bookingNumber);
        setValue('bookingAmount',response.data.total);
        setIsBookingIdVerified(true);
        setVerifyingBookingNumber(false);
        fetchPendingBookingAmount(bookingId);
      }
    }
  }

  return (
    <>
    <Box component={'form'} onSubmit={handleSubmit(handleFormSubmission)}>
      <Card sx={{p:2}}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={3}>
            <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Booking Number</Typography>          
              <Box sx={{display:"flex",gap:1}}>
                <Controller
                  name='bookingNumber'
                  control={control}
                  rules={{
                    required:true,
                    pattern: {
                      // Format: Only digits and "BI" letters allowed
                      // Must contain "BI" with at least 1 digit before and after
                      // Example: 151025144909BI2760
                      value: /^\d+BI\d+$/,
                      message: 'Invalid Booking Number. Only digits and "BI" allowed. Format: [digits]BI[digits]'
                    }
                  }}
                  render={({field,fieldState:{error}})=>(
                    <TextField
                      {...field}
                      disabled={isEdit}
                      fullWidth
                      size='small'
                      error={!!error}
                      inputProps={{
                        style:{
                          fontSize:'0.65rem'
                        },
                      }}
                     onChange={(e) => {
                      const inputValue = e.target.value.toUpperCase();
                      
                      // Validate: allow only digits and "BI"
                      if(inputValue === '' || /^[0-9BI]*$/.test(inputValue)) {
                        field.onChange(inputValue);
                      }
                    }}
                    />
                  )}
                />
                {isBookingIdVerified ?
                  !isEdit && <Typography sx={{fontSize:'0.65rem',color:'green',mt:1}}>Verified</Typography>
                  :
                  <Button variant="contained" size="small" disabled={!bookingNumber || verifyingBookingNumber} onClick={handleBookingNumberValidation}>{verifyingBookingNumber?'Verifying...':'Verify'}</Button>

                }
              </Box>
              
          </Grid>
          {isBookingIdVerified &&
            <>
              <Grid item md={3} sx={{display:{xs:'none',md:'block'}}}/>
              <Grid item xs={12} sm={4} md={3}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Booking Amount</Typography>
                <Controller
                  name='bookingAmount'
                  control={control}
                  rules={{required:true}}
                  defaultValue='0'
                  render={({field,fieldState:{error}})=>(
                    <TextField
                      {...field}
                      fullWidth
                      size='small'
                      error={!!error}
                      inputProps={{
                        style:{
                          fontSize:'0.65rem'
                        },
                      }}
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm= {4} md={3}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Pending Balance Amount</Typography>
                <Controller
                  name='bookingBalanceAmount'
                  control={control}
                  rules={{required:true}}
                  defaultValue='0'
                  render={({field,fieldState:{error}})=>(
                    <TextField
                      {...field}
                      fullWidth
                      size='small'
                      error={!!error}
                      inputProps={{
                        style:{
                          fontSize:'0.65rem'
                        },
                      }}
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
              <Divider sx={{borderBlockStyle:'dashed',borderBlockWidth:'1px'}}/>

              </Grid>
              
              <Grid item xs={12} md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Payment Method <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                    <Controller
                        control={control}
                        name="paymentMethod"
                        rules={{
                            required:'select Payment Method',
                        }}
                        render={({field,fieldState:{error}})=>(
                            <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                <Select
                                    {...field}
                                    error={!!error}
                                    sx={{
                                        fontSize:'0.65rem',
                                    }}
                                >
                                  <MenuItem value='CASH' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>CASH</MenuItem>
                                  <MenuItem value='UPI_QR' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>UPI-QR</MenuItem>
                                  <MenuItem value='APP_RAZORPAY' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>APP-Razorpay</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                      <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Expert Payment to Cudel Status <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                      <Controller
                          control={control}
                          name="expertPaymentStatus"
                          rules={{
                              required:'select expert Payment Status',
                          }}
                          render={({field,fieldState:{error}})=>(
                              <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                  <Select
                                      {...field}
                                      error={!!error}
                                      sx={{
                                          fontSize:'0.65rem',
                                      }}
                                      disabled={paymentMethod== 'APP_RAZORPAY' ? true : false}
                                  >
                                    <MenuItem value='TRANSFERRED_FULL' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Full Amount Transferred to CuDel</MenuItem>
                                    <MenuItem value='PAID_FEES_ONLY' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Paid Fess Only</MenuItem>
                                    <MenuItem value='PAID_PARTIAL' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Paid Partially</MenuItem>
                                    <MenuItem value='NOT_TRANSFERRED' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Not Transferred</MenuItem>
                                  </Select>
                              </FormControl>
                          )}
                      />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Reference Number </Typography>
                    <Controller
                      name='referenceNumber'
                      control={control}
                      rules={{ 
                        validate: (value) => {
                          if(value){
                            const words = value?.trim().split(/\s+/);
                            if (words.length > 100) {
                              return 'Please enter a description with 100 words or less';
                            }
                          }
                          return true;
                        }
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          size='small'
                          fullWidth
                          inputProps={{
                            style: { fontSize: '0.65rem' },
                          }}
                          error={!!error}
                          helperText={error?.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>customer Paid Amount (in Rs.)<span style={{ color: '#d32f2f' }}>*</span></Typography>
                    <Controller
                        name='customerPaidAmount'
                        control={control}
                        rules={{
                            required: "Enter customer Paid Amount",
                            validate: (value) => {
                                const floatValue = parseFloat(value);
                                if (isNaN(floatValue)) return 'Please enter a valid number';
                                // if (floatValue > 1000) return 'visiting charge should not exceed ₹1,000';
                                if (floatValue > 0 && floatValue < 1) return 'visiting charge should not be less than ₹1';
                                return floatValue >= 0 || 'visiting charge should not be negative';
                            }
                        }}
                        defaultValue={0}
                        render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                placeholder='0'
                                fullWidth
                                type="number"
                                disabled={paymentMethod == 'APP_RAZORPAY'}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  let finalValue;
                                  if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {                                
                                    finalValue = formatValue(inputValue);
                                    if(finalValue==''){
                                        finalValue=0
                                    }

                                    field.onChange(finalValue);
                                  }
                                }}
                                inputMode="decimal"
                                size="small"
                                inputProps={{
                                    style: { textAlign: 'center', height: '1rem', fontSize: '0.75rem' },
                                    min: 0,
                                    // max: 10000,
                                    step: 0.01, // Allow two decimal places
                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                    onKeyDown: (e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                error={!!error}
                            />
                        )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Cudel Amount Received (in Rs.)<span style={{ color: '#d32f2f' }}>*</span></Typography>
                    <Controller
                        name='amountReceived'
                        control={control}
                        rules={{
                            required: "Enter Cudel Amount Received",
                            validate: (value) => {
                                const floatValue = parseFloat(value);
                                if (isNaN(floatValue)) return 'Please enter a valid number';
                                // if (floatValue > 1000) return 'visiting charge should not exceed ₹1,000';
                                if (floatValue > 0 && floatValue < 1) return 'visiting charge should not be less than ₹1';
                                return floatValue >= 0 || 'visiting charge should not be negative';
                            }
                        }}
                        defaultValue={0}
                        render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                placeholder='0'
                                fullWidth
                                type="number"                      
                                disabled={paymentMethod == 'APP_RAZORPAY' || expertPaymentStatus == 'TRANSFERRED_FULL' || expertPaymentStatus == 'NOT_TRANSFERRED'}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  let finalValue;
                                  if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {                                
                                    finalValue = formatValue(inputValue);
                                    if(finalValue==''){
                                        finalValue=0
                                    }

                                    field.onChange(finalValue);
                                  }
                                }}
                                inputMode="decimal"
                                size="small"
                                inputProps={{
                                    style: { textAlign: 'center', height: '1rem', fontSize: '0.75rem' },
                                    min: 0,
                                    // max: 10000,
                                    step: 0.01, // Allow two decimal places
                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                    onKeyDown: (e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                error={!!error}
                            />
                        )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Paid Balance Amount (in Rs.)<span style={{ color: '#d32f2f' }}>*</span></Typography>
                    <Controller
                        name='paidBalanceAmount'
                        control={control}
                        // rules={{
                        //     // required: "Enter Cudel Amount Received",
                        //     validate: (value) => {
                        //         const floatValue = parseFloat(value);
                        //         if (isNaN(floatValue)) return 'Please enter a valid number';
                        //         // if (floatValue > 1000) return 'visiting charge should not exceed ₹1,000';
                        //         if (floatValue > 0 && floatValue < 1) return 'visiting charge should not be less than ₹1';
                        //         return floatValue >= 0 || 'visiting charge should not be negative';
                        //     }
                        // }}
                        defaultValue={0}
                        render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                placeholder='0'
                                fullWidth
                                type="number"
                                disabled
                                inputMode="decimal"
                                size="small"
                                value={parseFloat(field.value).toFixed(2)}
                                inputProps={{
                                    style: { textAlign: 'center', height: '1rem', fontSize: '0.75rem' },
                                    min: 0,
                                    // max: 10000,
                                    step: 0.01, // Allow two decimal places
                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                    onKeyDown: (e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                error={!!error}
                            />
                        )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{fontSize:'0.75rem',fontWeight:600}}>Tip/Adjustment Type <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                    <Controller
                        control={control}
                        name="tipAdjustmentType"
                        rules={{
                            required:'select expert Payment Status',
                        }}
                        render={({field,fieldState:{error}})=>(
                            <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                <Select
                                  {...field}
                                  error={!!error}
                                  sx={{
                                      fontSize:'0.65rem',
                                  }}
                                  disabled={paidBalanceAmount== 0 || paidBalanceAmount<0}
                                >
                                  {paidBalanceAmount== 0 && <MenuItem value='NONE' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>None</MenuItem>}
                                  <MenuItem value='TIP' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Tip</MenuItem>
                                  <MenuItem value='ADJUSTMENT' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Adjustment</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payout Eligiblity </Typography>
                  {/* <Controller
                    name='isPayoutEligible'
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        size='small'
                        fullWidth
                        inputProps={{
                          style: { fontSize: '0.65rem',textTransform:'capitalize' },
                        }}
                        error={!!error}
                        disabled

                      />
                    )}
                  /> */}
                  <Controller
                    control={control}
                    name="isPayoutEligible"
                    rules={{
                        required:'select Payment Method',
                    }}
                    render={({field,fieldState:{error}})=>(
                        <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                            <Select
                                {...field}
                                error={!!error}
                                sx={{
                                    fontSize:'0.65rem',
                                }}
                            >
                              <MenuItem value='true' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Eligible</MenuItem>
                              <MenuItem value='false' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Not Eligible</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                />
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payment Remarks </Typography>
                  <Controller
                    name='paymentRemarks'
                    control={control}
                    rules={{ 
                      validate: (value) => {
                        if(value){
                          const words = value?.trim().split(/\s+/);
                          if (words.length > 25) {
                            return 'Please enter a Payment Remarks with 25 words or less';
                          }
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        size='small'
                        fullWidth
                        multiline
                        // rows={3}
                        inputProps={{
                          style: { fontSize: '0.65rem' },
                        }}
                        error={!!error}
                        placeholder='.... upto 25 words only'
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Customer Feedback </Typography>
                  <Controller
                    name='customerFeedback'
                    control={control}
                    rules={{ 
                      validate: (value) => {
                        if(value){
                          const words = value?.trim().split(/\s+/);
                          if (words.length > 25) {
                            return 'Please enter a Customer Feedback with 25 words or less';
                          }
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        size='small'
                        fullWidth
                        multiline
                        // rows={3}
                        inputProps={{
                          style: { fontSize: '0.65rem' },
                        }}
                        error={!!error}
                        placeholder='.... upto 25 words only'
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>
                      Image <Box component="span" sx={{ color: 'error.main' }}>{(paymentMethod!== 'APP_RAZORPAY'&& paymentMethod!== 'CASH') && '*'}</Box>
                    </Typography>

                    <Box sx={{ textAlign: 'center'}}>
                      <Box sx={{height: '11rem',border:'1px dashed gray',borderRadius:'4px',mb:1}}>                        
                        {(imageUploadResponseDetails.imageName || bookingPaymentData.image) && (
                          <Box
                            sx={{
                              position: 'relative',
                              width: '100%',maxWidth: '100%' ,maxHeight:'100%',
                              overflow: 'hidden',
                              '&:hover .overlay': {
                                opacity: 1,
                              },
                            }}
                          >
                            <img
                              src={`${Helpers.ImagePathUrl()}/booking-payment/${imageUploadResponseDetails.imageName || bookingPaymentData.image}`}
                              alt="Uploaded"
                              style={{ maxWidth: '100%' ,maxHeight:'100%', display: 'block', margin: '0 auto' }}
                            />
                            
                            <Box
                              className="overlay"
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: 0,
                                transition: 'opacity 0.3s ease-in-out',
                              }}
                            >
                              {/* <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: 'white',
                                  color: 'black',
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                  },
                                }}
                              >
                                View
                              </Button> */}
                              {/* Eye icon overlay - appears on hover */}
                              <IconButton
                                size="small"
                                aria-label="preview"
                                onClick={() => openImagePreview(`${Helpers.ImagePathUrl()}/booking-payment/${imageUploadResponseDetails.imageName || bookingPaymentData.image}`)}
                                sx={{
                                  // position: 'absolute',
                                  right: 8,
                                  top: 8,
                                  bgcolor: 'rgba(0,0,0,0.45)',
                                  color: '#fff',
                                  '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
                                  // opacity: 0,
                                  // transition: 'opacity 0.15s',
                                  // // show on hover of container
                                  // '.MuiBox-root:hover &': {
                                  //   opacity: 1,
                                  // }
                                }}
                              >
                                <Visibility />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>

                        <Button
                            onClick={openImgModal}
                            // disabled={isSubmitting}
                            variant="outlined"
                            startIcon={<AddToPhotos />}
                            size="small"
                            fullWidth
                        >
                            {imageUploadResponseDetails.imageName || bookingPaymentData.image ? 'Change Image' : 'Select Image'}
                        </Button>
                    </Box>

                    <Controller
                        control={control}
                        name='image'
                        rules={{
                          required: (paymentMethod!== 'APP_RAZORPAY'&& paymentMethod!== 'CASH') && 'Please upload an image' 
                        }}
                        render={({ fieldState: { error } }) => (
                            error && (
                                <Typography color="error" variant="caption" display="block" textAlign="center">
                                    {error.message}
                                </Typography>
                            )
                        )}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:'1%'}}>
                <Button disabled={!isDirty} size='small' type='submit' variant='contained' color='primary' sx={{textTransform:'capitalize'}}>{isEdit? 'Update':'Save'}</Button>
                <Button size='small' variant='contained' color='error' sx={{textTransform:'capitalize'}}
                  onClick={()=>{
                    reset(initialState);
                    closePaymentEntryDialog();
                  }}
                >Cancel</Button>
              </Grid>
            </>
          }
        </Grid> 
        
      </Card>
    </Box>
    {/* ============== image upload dialog ============= */}
        <ImgUploadDialog open={imgModalOpen} onClose={closeModal}
            imgData={imgData}
            imgUploadResponse={imgUploadResponse}
        />  
        {/* Image preview dialog with zoom controls*/}
        
        <Modal
          open={previewOpen}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: { xs: '50%', sm: '50%' },
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              p: 0,
              width: { xs: "95%",md:'50%' },
              minHeight: '25%',
              maxHeight: '90%',
              display: 'flex',
              flexDirection: 'column'
            }}
            borderRadius={2}
          >
            <Box sx={{ 
              borderBottom: '1px solid lightGray', 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              p: '1% 2%',
              flexShrink: 0
            }}>
              <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
                Image Viewer
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton size="small" onClick={zoomOut} aria-label="zoom-out" title="Zoom Out">
                  <ZoomOut fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={resetZoom} aria-label="fit" title="Reset Zoom">
                  <FitScreen fontSize="small" />
                </IconButton>
                <IconButton size="small" onClick={zoomIn} aria-label="zoom-in" title="Zoom In">
                  <ZoomIn fontSize="small" />
                </IconButton>
                <IconButton
                  size='small'
                  onClick={closeImagePreview}
                  sx={{ p: 0 }}
                  color='error'
                >
                  <Close sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
                </IconButton>
              </Box>
            </Box>
            
            {previewSrc && (
              <Box
                sx={{
                  flex: 1,
                  overflow: 'auto',
                  p: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 0
                }}
              >
                <Box
                  component="img"
                  src={previewSrc}
                  alt="Preview"
                  sx={{
                    transform: `scale(${zoom})`,
                    transformOrigin: 'top left',
                    transition: 'transform 0.2s ease-out',
                    maxWidth: zoom <= 1 ? '100%' : 'none',
                    maxHeight: zoom <= 1 ? '100%' : 'none',
                    width: zoom > 1 ? `${100 * zoom}%` : 'auto',
                    height: 'auto',
                    display: 'block',
                    cursor: zoom > 1 ? 'grab' : 'default',
                    userSelect: 'none',
                    '&:active': {
                      cursor: zoom > 1 ? 'grabbing' : 'default'
                    }
                  }}
                  // onWheel={(e) => {
                  //   e.preventDefault();
                  //   if (e.deltaY < 0) zoomIn(); 
                  //   else zoomOut();
                  // }}
                  draggable={false}
                />
              </Box>
            )}
          </Box>
        </Modal>
    </>
  )
}

export default AddEditPayment
const formatValue = (value) => {
    if (!value) return '';  // Return empty string instead of 0
    const numValue = parseFloat(value);
    return isNaN(numValue) ? '' : numValue.toString();
};